import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Vr = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M8 12.378c-1.746 0-3.416-1.344-4.266-3.218l.607-.275c.78 1.72 2.256 2.826 3.659 2.826s2.878-1.107 3.658-2.826l.607.275c-.85 1.874-2.52 3.218-4.265 3.218ZM5.329 1.153a4.993 4.993 0 0 1 7.183 2.083l-.603.285a4.326 4.326 0 0 0-7.82 0l-.603-.285A4.993 4.993 0 0 1 5.33 1.153ZM3.666 5.045h8.666v.667H3.666v-.667Z" />
        <path d="M2.057 3.435c.25-.25.589-.39.942-.39h10a1.333 1.333 0 0 1 1.333 1.333v3.667A1.333 1.333 0 0 1 13 9.378H9.481l-.804-1.287a.8.8 0 0 0-1.356 0l-.804 1.287H3a1.333 1.333 0 0 1-1.333-1.333V4.378c0-.353.14-.693.39-.943Zm.942.277a.667.667 0 0 0-.666.666v3.667a.667.667 0 0 0 .666.666h3.149l.608-.974a1.467 1.467 0 0 1 2.486 0l.609.974h3.148a.667.667 0 0 0 .667-.666V4.378a.667.667 0 0 0-.667-.666H3ZM5.332 12.235v-1.083H6v1.083a2.333 2.333 0 0 1-1.647 2.229l-2.921.9-.197-.637 2.922-.9a1.667 1.667 0 0 0 1.176-1.592ZM10.667 12.235v-1.083Zm0-1.083H10Zm-.667 0v1.083Zm.667 1.083a1.667 1.667 0 0 0 1.176 1.592l2.922.9-.197.637-2.921-.9A2.333 2.333 0 0 1 10 12.235" />
      </g>
    </svg>
  );
};

Vr.category = 'product-category';

Vr.displayName = 'Vr';
